import { inject, Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { User } from './user.types';
import { GuestUser } from 'app/shared/model';
import { GlobalService } from 'app/shared/services/global.service';

@Injectable({ providedIn: 'root' })
export class UserService
{
    // private _securityService: SecurityServiceProxy = inject(SecurityServiceProxy);
    private _globalService: GlobalService = inject(GlobalService);

    private _user: ReplaySubject<User | undefined> = new ReplaySubject<User | undefined>(1);
    private _guestUser: ReplaySubject<GuestUser | undefined> = new ReplaySubject<GuestUser | undefined>(1);

    /**
     * Setter & getter for user
     *
     * @param value
     */
    set user(value: User | undefined) {
        // Store the value
        const user = this.preProcess(value);
        this._globalService.setCurrentUserId(user?.id);
        this._user.next(user);
    }

    get user$(): Observable<User | undefined> {
        return this._user.asObservable();
    }

    set guestUser(value: GuestUser | undefined) {
        this._guestUser.next(value);
    }

    get guestUser$(): Observable<GuestUser | undefined> {
        return this._guestUser.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get the current signed-in user data
     */
    get(): Observable<User | undefined> {
        return this._user.asObservable();
    }

    preProcess(user?: User): User | undefined {
        if (!user || !user.id) {
            return undefined;
        }

        // const hash = user.emailHash.toLocaleLowerCase();
        // const hash = CryptoJS.MD5(user.emailAddress);
        // const fallback = 'https://evatar.io/' + CryptoJS.SHA256(user.emailAddress); // 'https://imgur.com/VsVD0eI.png'
        // https://unavatar.io/#/

        // user.avatar = 'https://www.gravatar.com/avatar/'+
        //     hash +
        //     '?r-pg&s=200'+
        //     '&d=' + encodeURIComponent(fallback); // 'mp'; 'retro';

        return user;
    }

    getInitials(name: string): string {
        if (!name) {
            return '';
        }
        const parts = name.split(' ');
        if (parts.length === 1) {
            return parts[0].charAt(0).toUpperCase();
        }
        return parts[0].charAt(0).toUpperCase() + parts[parts.length - 1].charAt(0).toUpperCase();
    }
}
